import { useMutation } from '@tanstack/react-query'
import { CARD_API_ENDPOINT } from '@/config/consts'
import { createSmartFetch } from './useAuthenticatedMutation'

interface CreditProviderConfig {
  aTokenAddress?: string
  purchaseBaseTokenAddress?: string
  borrowTokenAddress?: string
  // Euler-specific fields
  borrowVaultAddress?: string
  subAccountId?: number
}

interface CreditProviderRequest {
  chainID: number
  solverType: string
  cardID: string
  cardSolverConfig: CreditProviderConfig
}

interface UpdateCreditProviderParams {
  chainId: number
  creditType: string
  cardID: string
  cardSolverConfig: CreditProviderConfig
}

export function useCreditProvider() {
  const updateUrl = `${CARD_API_ENDPOINT}/v1/vendor/cards/creditprovider`

  return useMutation<any, Error, UpdateCreditProviderParams>({
    mutationFn: async (params: UpdateCreditProviderParams) => {
      const payload: CreditProviderRequest = {
        chainID: params.chainId,
        solverType: params.creditType,
        cardID: params.cardID,
        cardSolverConfig: params.cardSolverConfig,
      }

      const smartFetch = createSmartFetch(updateUrl, { method: 'PATCH' })
      return smartFetch(payload)
    },
    retry: (failureCount, error) => {
      const msg = error instanceof Error ? error.message : ''
      if (msg.includes('Authentication failed')) {
        return false
      }
      return failureCount < 2
    },
  })
}
